import { ref } from "vue";
import type { CreateDssConnectionSettingMutation, CreateChainMutation } from "@/generated/graphql";

/**
 * チェーン登録 UI状態管理を扱う composable。
 * ダイアログ表示・ローディング・登録結果を一元管理する。
 */
export const useChainRegisterUiState = () => {
  //エラーダイアログ
  const errdialog = ref<boolean>(false);
  //エラーメッセージ
  const errMessage = ref<string>("");

  //Loading
  const overlay = ref<boolean>(false);

  //ダイアログ初期化
  const displayConfirmDialog = ref<boolean>(false);
  const displayCompletedDialog = ref<boolean>(false);

  // DSS接続設定作成 レスポンス
  const dssConnectionSettingMutation = ref<CreateDssConnectionSettingMutation | null>(null);

  // チェーン作成 レスポンス
  const createChainMutation = ref<CreateChainMutation | null>(null);

  return {
    errdialog,
    errMessage,
    overlay,
    displayConfirmDialog,
    displayCompletedDialog,
    dssConnectionSettingMutation,
    createChainMutation,
  };
};
